import React, { CSSProperties, FunctionComponent } from 'react'

export type AgTechActionPaneProps = {
    classes?: string,
    styles?: CSSProperties,
    elements: React.ReactNode[],
    customization?: AgTechActionPaneCustomizationProps
}

export type AgTechActionPaneCustomizationProps = {
    showDividers?: boolean,
    padLastElement?: boolean,
    elementClasses?: string,
    minElements?: number,
    width?: number
}

const AgTechActionPane = (props: AgTechActionPaneProps) => {
    const shouldShowDividers = props.customization?.showDividers ?? true;
    const elements = [...props.elements];

    if (props.customization?.minElements && props.customization.minElements > elements.length) {
        for (let i = 0; i < props.customization.minElements - elements.length; i++) {
            elements.push(undefined);
        }
    }

    return (
        <div className={`column-based items-center stretched flex ${props.classes ?? ''}`} style={props.styles}>
            {elements.map((elem, index) => {
                const leftPadding = index === 0 ? '' : 'pl-4';
                const rightPadding = (shouldShowDividers && index !== props.elements.length - 1) || props.customization?.padLastElement ? 'pr-4' : '';
                const borderClass = shouldShowDividers && index !== props.elements.length - 1 ? 'border-r' : '';

                return (
                    <div
                        key={index}
                        className={`row-based justify-center tall flexed ${leftPadding} ${rightPadding} ${borderClass} ${props.customization?.elementClasses ?? ''} flex`}
                        style={props.customization?.width ? { minWidth: props.customization.width } : undefined}
                    >
                        {elem}
                    </div>
                )
            })}
        </div>
    )
};

export default AgTechActionPane;